import { createFileRoute } from "@tanstack/react-router";

import { CatalogStep } from "~/pages/onboard/steps/catalog-step";

/**
 * Catalog progress screen. Shown after the user creates their first
 * datasource in the wizard. The id-bearing path means the URL is
 * shareable / refreshable without losing context.
 */
export const Route = createFileRoute("/onboard/catalog/$datasourceId")({
  component: () => {
    const { datasourceId } = Route.useParams();
    return <CatalogStep datasourceId={datasourceId} />;
  },
});
